import { c as _c } from "react/compiler-runtime";
import React from "react";
interface MemeWinnerHeaderProps {
  readonly title: string;
}
export default function MemeWinnerHeader(t0) {
  const $ = _c(2);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="tw-flex tw-flex-col tw-gap-y-3 sm:tw-gap-y-2 tw-items-start"><h3 className="tw-text-lg tw-font-semibold tw-text-iron-100 tw-mb-0">{title}</h3></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}